import { render, staticRenderFns } from "./coachDetails.vue?vue&type=template&id=e6d720ba&"
import script from "./coachDetails.vue?vue&type=script&lang=js&"
export * from "./coachDetails.vue?vue&type=script&lang=js&"
import style0 from "./coachDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports